<script setup lang="ts">
import UiMenuDialog from '@/components/ui/menu/dialog/index.vue'
import type { ECharts } from 'echarts'
import type { Values } from '@/composables/useValues'

defineProps<{
    title?: string
    instance?: ECharts
    dimension?: Dimension
    data?: Values
}>()

const { isLargeDesktop } = useDeviceType()
</script>

<template>
    <UiToolbar>
        <Tutorial class="h-6 flex-shrink-0" />

        <component
            :is="isLargeDesktop ? 'div' : UiMenuDialog"
            class="order-2 flex flex-col gap-4 xl:order-1 xl:flex-row"
        >
            <template #trigger="{ toggle }">
                <ToolbarMobileTrigger :toggle="toggle" />
            </template>
            <slot :dimension="dimension" :data="data" />
        </component>

        <div
            v-if="instance"
            class="order-1 flex flex-1 flex-shrink-0 items-center justify-end xl:order-2"
        >
            <ChartTools
                bordered
                :instance="instance"
                :title="title"
                direction="top-right"
            />
        </div>
    </UiToolbar>
</template>